export default __webpack_public_path__ + "static/media/fruit & veg_cat.fe4df7dd.jpg";